
export const Jurisdicciones = [
  { 
    nombre:"1 Tula de Allende", 
    direccion:"Av. Reforma #100, Col. Apepechoca, C.P. 42957",
    localidad:"Tlaxcoapan, Hgo.",
    telefono:"(778)7371126",
    latitud:"20.08274",
    longitud:"-99.222752",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Ajacuba, Atitalaquia, Atotonilco de Tula, Tepeji del Río de Ocampo, Tepetitlán, Tetepango, Tezontepec de Aldama, Tlahuelilpan, Tlaxcoapan, Tula de Allende",
  },
  { 
    nombre:"2 Tulancingo de Bravo", 
    direccion:"Calle General Lázaro Cárdenas #200, Col. Centro, C.P. 43600",
    localidad:"Tulancingo de Bravo, Hgo.",
    telefono:"(775)7532276",
    latitud:"20.077067",
    longitud:"-98.37327",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Acatlán, Acaxochitlán, Agua Blanca de Iturbide, Cuautepec de Hinojosa, Huehuetla, Metepec, San Bartolo Tutotepec, Santiago Tulantepec, Singuilucan, Tenango de Doria, Tulancingo de Bravo",
  },
  { 
    nombre:"3 Pachuca de Soto",
    direccion:"Prolongación Narciso Mendoza #301, Col. Morelos, C.P. 42040",
    localidad:"Pachuca de Soto, Hgo.",
    telefono:"(771)7191479",
    latitud:"20.1240088",
    longitud:"-98.7416707",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Pachuca de Soto, San Agustín Tlaxiaca, Zapotlán de Juárez",
  },
  { 
    nombre:"4 Huejutla de Reyes", 
    direccion:"Calle La Lomita #1, Col. La Lomita, C.P. 43000",
    localidad:"Huejutla de Reyes, Hgo.",
    telefono:"(789)8961453",
    latitud:"21.138748",
    longitud:"-98.409389",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Atlapexco, Calnali, Huautla, Huazalingo, Huejutla de Reyes, Jaltocán, Lolotla, San Felipe Orizatlán, Tlanchinol, Xochiatipan, Yahualica",
  },
  { 
    nombre:"5 Mineral de la Reforma", 
    direccion:"Prolongación Francisco I. Madero S/N, Col. Centro, C.P. 42180",
    localidad:"Pachuquilla, Hgo.",
    telefono:"(771)6093396",
    latitud:"20.0717543",
    longitud:"-98.6961092",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Epazoyucan, Huasca de Ocampo, Mineral del Chico, Mineral del Monte, Omitlán de Juárez, Mineral de la Reforma",
  },
  { 
    nombre:"6 Tizayuca", 
    direccion:"Calle Cuauhtémoc S/N, Barrio Nacozari, C.P. 43803",
    localidad:"Tizayuca, Hgo.",
    telefono:"(779)7964102",
    latitud:"19.837939",
    longitud:"-98.976686",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Villa de Tezontepec, Tizayuca, Tolcayuca, Zempoala",
  },
  { 
    nombre:"7 Actopan", 
    direccion:"Calle 16 de Septiembre #125, Col. Chapultepec, C.P. 42504",
    localidad:"Actopan, Hgo.",
    telefono:"(772)7270654",
    latitud:"20.264218",
    longitud:"-98.941143",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Actopan, El Arenal, Francisco I. Madero, Mixquiahuala de Juárez, Progreso de Obregón, San Salvador, Santiago de Anaya",
  },
  { 
    nombre:"8 Ixmiquilpan", 
    direccion:"Calle Francisco Javier Mina #15, Barrio El Carmen, C.P. 42300",
    localidad:"Ixmiquilpan, Hgo.",
    telefono:"(759)7230088",
    latitud:"20.480055",
    longitud:"-99.218151",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Alfajayucan, Cardonal, Chilcuautla, Ixmiquilpan, Nicolás Flores, Tasquillo, Zimapán",
  },
  { 
    nombre:"9 Zacualtipán de Ángeles",
    direccion:"Calle Los Pinos #1, Col. Los Pinos, C.P. 43200",
    localidad:"Zacualtipán de Ángeles, Hgo.",
    telefono:"(774)7420599",
    latitud:"20.663869",
    longitud:"-98.665521",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Atotonilco el Grande, Eloxochitlán, Juárez Hidalgo, San Agustín Metzquititlán, Metztitlán, Molango de Escamilla, Tepehuacán de Guerrero, Tianguistengo, Tlahuiltepa, Xochicoatlán, Zacualtipán de Ángeles",
  },
  { 
    nombre:"10 Apan", 
    direccion:"Calle Ignacio Zaragoza #25 esq. José Ma. Morelos, Col. Dina, C. P. 43995",
    localidad:"Apan, Hgo.",
    telefono:"(791)9169564",
    latitud:"19.770552",
    longitud:"-98.572603",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Almoloya, Apan, Emiliano Zapata, Tepeapulco, Tlanalapa",
  },
  { 
    nombre:"11 Huichapan", 
    direccion:"Calle Parque de los Villagrán S/N, Col. San Mateo, C.P. 42403",
    localidad:"Huichapan, Hgo.",
    telefono:"(773)7820051",
    latitud:"20.380285",
    longitud:"-99.650439",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Chapantongo, Huichapan, Nopala de Villagrán, Tecozautla",
  },
  { 
    nombre:"12 Jacala de Ledezma",
    direccion:"Calle Juventino Rosas #106, Col. El Cerrito, C.P. 42200",
    localidad:"Jacala de Ledezma, Hgo.",
    telefono:"(771)2111147",
    latitud:"21.008128",
    longitud:"-99.192922",
    horario:"8:30 a 16:30 hrs.",
    municipios:"Chapulhuacán, Jacala de Ledezma, La Misión, Pacula, Pisaflores",
  },
];

